import React, { ReactNode } from "react";
import Footer from "./footer";
import { GlobalStyle, Main } from "@styles/globalStyles";
import { Helmet } from "react-helmet";
import Header from "./header";
import { HeaderDesign } from "@util/types";
import { Maybe } from "@graphql-types";
interface Props {
  children: ReactNode;
  data?: any;
  headerOverride?: HeaderDesign;
  page: any;
  pageIban: Maybe<string> | undefined;
  notFound: boolean;
}

function Layout(props: Props) {
  const { children, headerOverride, page, pageIban, notFound } = props;

  const fullPageSlug = [
    "/",
    "brands/5-surprise",
    "brands/mini-brands",
    "brands/sparkle-girlz",
    "brands/bunch-o-balloons",
    "brands/robo-alive",
    "brands/x-shot",
    "brands/coco-cones",
    "brands/metal-machines",
    "brands/smashers",
    "brands/x-shot-water",
  ];
  const isPageIncludesFullPageSlug = fullPageSlug.includes(page);
  const className = isPageIncludesFullPageSlug ? "full-page-scroll" : "reset-scroll";
  return (
    <div>
      <Helmet>
        <link rel="stylesheet" href="https://use.typekit.net/osv8rus.css" />
        <link
          rel="preload"
          href="/fonts/EurostileBQ-BoldExtended.woff2"
          as="font"
          type="font/woff2"
        />
      </Helmet>
      <GlobalStyle />
      <div className={`scroll-behavior ${className}`}>
        {((!page?.includes(`brands/x-shot/lock-blaster/code`) && !page?.includes(`snackles`)) ||
          notFound) && <Header design={headerOverride} />}
        <Main>{children}</Main>
        {/* To Hide Footer in below url */}
        {((!page?.includes(`brands/x-shot/lock-blaster/code`) && !page?.includes(`snackles`)) ||
          notFound) && <Footer pageIban={pageIban} />}
      </div>
    </div>
  );
}

export default Layout;
